// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2xfUj","unreadBadge":"styles_unreadBadge__pOQxY","modalContent":"styles_modalContent__DnPoo","modal":"styles_modal__3hyCv"};